import Swiper, {Navigation, Pagination} from "swiper";

export default (el) => {
  const bestSellingEl = el.querySelector('.js-p-home-best-selling')

  new Swiper(bestSellingEl, {
    modules: [Pagination, Navigation],
    slidesPerView: 1.4,
    spaceBetween: 12,
    autoHeight: true,
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: '.js-best-selling-next',
      prevEl: '.js-best-selling-prev',
    },
    breakpoints: {
      768: {
        slidesPerView: 3.4,
      },
      992: {
        slidesPerView: 4.4,
      },
      1200: {
        slidesPerView: 4.4,
        spaceBetween: 16,
        pagination: false,
      }
    },
  })
}
